import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import carImg from 'images/tmp_car_image.png'
import styles from './index.module.css'

const MyCarMain = () => {

	const App = useApp()
	const [carData, setCarData] = useState()
	const [showLayer, setShowLayer] = useState(false)

	const dataOpen = () => {
		setCarData(!carData)
	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>내 차 보기</h3>
						<span className={styles["add-btn"]}>+ 추가</span>
					</div>
					<div className={`${styles["car-detail-box"]} mt_40`}>
						<span>총 시세 금액</span>
						<strong>1억 5,000만원</strong>
					</div>
					<div className="slider mt_40 pt_20">
						<ul>
							<li>
								<div className="flex-justify_end mt_10">
									<i className="icon icon_tab_best" style={{ width: "2rem", height: "2rem" }} />
								</div>
								<div className="img-box mt_10" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
									<img src={carImg} alt="" />
								</div>
								<span className="license-plate mt_35">245 무 1245</span>

								{/* 업데이트 실패 */}
								<div className="flex-align_center mt_35">
									<span className="license-plate">245 무 1245</span>
									<div className="flex-align_center ml_10">
										<span className="text-red" style={{ fontSize: "1.4rem" }}>업데이트 실패</span>
										<i className="icon icon_error_update ml_5" />
									</div>
								</div>

								<div className="car-info mt_20">
									<div>
										<span>테슬라</span>
										<span>테슬라 모델X</span>
									</div>

									{/* 차량 세부모델명 하나일 때 */}
									<p>조대리님 미래 2058년의 차 테슬라 모델X</p>

									{/* 차량 세부모델명 리스트로 나올 때 */}
									<div className={`${styles["car-name-wrap"]} ${carData ? styles.active : ""}`} onClick={dataOpen}>
										<div className="flex-justify_between align_center">
											<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
											<i className="icon icon_arrow_sm bottom gray" />
										</div>
										<div>
											<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
										</div>
									</div>

									<div className="warn-txt mt_10" onClick={openLayer}>미납 금액이 있어요.</div>
								</div>
								<div className="car-price mt_20"><strong className="text-blue">7,750</strong> 만원</div>
								<ul className="my-info-box mt_30">
									<li>
										<span>미납</span>
										<span className="text-red">통행료 미납</span>
									</li>
									<li>
										<span>보험</span>
										<span className="text-red">만기 D-30</span>
									</li>
									<li>
										<span>검사</span>
										<span style={{ color: "#333" }}>만기 D-123</span>
									</li>
								</ul>
							</li>
						</ul>
						<ul className="slider-dots dots-gray" style={{ position: "absolute", right: 0, top: 0 }}>
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>
				</div>
			</div>
			<div className="padding pb_20">
				<div className={`${styles["car-title"]} mt_10`}>
					<strong>20대 남자</strong> 김모니님에게<br />어울리는 차는?
				</div>
			</div>
			<ul className={`${styles["recommend-car-list"]} list-bg pb_20`}>
				<li>
					<div className="img-box" style={{ width: "10rem", height: "5rem" }}>
						<img src={carImg} alt="" />
					</div>
					<div className="flex--item_1 ml_20">
						<p>제네시스 2022 GV60</p>
						<span className="mt_5">스탠다드</span>
						<div className={`${styles.price} mt_10`}>1억 500만원 ~ 3,280만원</div>
					</div>
				</li>
				<li>
					<div className="img-box" style={{ width: "10rem", height: "5rem" }}>
						<img src={carImg} alt="" />
					</div>
					<div className="flex--item_1 ml_20">
						<p>제네시스 2022 GV60</p>
						<span className="mt_5">스탠다드</span>
						<div className={`${styles.price} mt_10`}>1억 500만원 ~ 3,280만원</div>
					</div>
				</li>
				<li>
					<div className="img-box" style={{ width: "10rem", height: "5rem" }}>
						<img src={carImg} alt="" />
					</div>
					<div className="flex--item_1 ml_20">
						<p>제네시스 2022 GV60</p>
						<span className="mt_5">스탠다드</span>
						<div className={`${styles.price} mt_10`}>1억 500만원 ~ 3,280만원</div>
					</div>
				</li>
			</ul>
			<NonpaymentLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const NonpaymentLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text py_10">
				차량에 현재 고속도로 통행료 미납이 발생했어요.<br />
				한국도로공사 홈페이지에서 상세 정보 확인 및 납부가<br />
				가능해요.
				<div className="mt_10 text-blue flex-align_center" style={{ fontWeight: 500 }}>
					한국도로공사 홈페이지 확인하기 <i className="icon icon_btn_arrow_blue ml_10" />
				</div>
			</div>
		</LayerBottom>
	)
}

export default MyCarMain